import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=fea669f2&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=js"
export * from "./eventDetail.vue?vue&type=script&lang=js"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=fea669f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea669f2",
  null
  
)

export default component.exports